import { createFeatureSelector, createReducer, on } from '@ngrx/store';
import { UserModel } from '../../models/user.model';
import * as userActions from '../actions/user.actions';

export interface UserState {
  user: UserModel | null;
  loading: boolean;
  error: any | null | undefined;
}

export const initialState: UserState = {
  user: null,
  loading: false,
  error: null,
};

export const getUserState = createFeatureSelector<UserState>('user');
export const user = (state: UserState) => state.user;

export const userReducer = createReducer(
  initialState,
  on(userActions.loadUser, (state) => ({ ...state, loading: true })),
  on(userActions.getUser, (state) => ({ ...state, loading: true })),
  on(userActions.loadUserSuccess, (state, { user }) => ({
    user: user,
    loading: false,
    error: null,
  })),
  on(userActions.signup, (state) => ({ ...state, loading: true })),
  on(userActions.signupSuccess, (state) => ({ ...state, loading: false })),
  on(userActions.signupFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(userActions.verifyEmail, (state) => ({ ...state, loading: true })),
  on(userActions.verifyEmailSuccess, (state) => ({ ...state, loading: false })),
  on(userActions.verifyEmailFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(userActions.resetPassword, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(userActions.resetPasswordSuccess, (state) => ({
    ...state,
    loading: false,
    error: null,
  })),
  on(userActions.resetPasswordFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(userActions.update, (state) => ({ ...state, loading: true, error: null })),
  on(userActions.updateSuccess, (state, { user }) => ({
    user: user,
    loading: false,
    error: null,
  })),
  on(userActions.updateFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(userActions.deleteImage, (state) => ({ ...state, loading: true })),
  on(userActions.emailLogin, (state) => ({
    ...state,
    loading: true,
  })),
  on(userActions.googleLogin, (state) => ({ ...state, loading: true })),
  on(userActions.authenticated, (state) => ({ ...state, loading: false })),
  on(userActions.loginSuccess, (state, { user }) => ({
    user: user,
    loading: false,
    error: null,
  })),
  on(userActions.loginFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(userActions.clearError, (state) => ({
    ...state,
    error: undefined,
  })),
  on(userActions.notAuthenticated, (state) => initialState),
  on(userActions.logout, (state) => ({ ...state })),
  on(userActions.logoutSuccess, (state) => initialState)
);
